import { createApp } from 'vue'
import App from './App.vue'

import './registerServiceWorker'
import router from './router'
import './assets/tailwind.css'
import axios from './axios'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'

// import { i18n } from "./i18n";

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)
import { far } from '@fortawesome/free-regular-svg-icons'
library.add(far)
import { dom } from '@fortawesome/fontawesome-svg-core'
dom.watch()

dayjs.locale('ja')

const app = createApp(App)

app.config.globalProperties.dayjs = dayjs

app.use(router, axios).mount('#app')

app.component('font-awesome-icon', FontAwesomeIcon)

app.config.globalProperties.$filters = {
  wareki(value) {
    const opt = { year: 'numeric', month: 'long', day: 'numeric' }
    return new Date(value).toLocaleDateString('ja-JP-u-ca-japanese', opt)
  },

  dateFormat(value) {
    if (!value) return ''
    // const opt = { year: 'numeric', month: '2-digit', day: '2-digit' }
    // return new Date(value.replace(/-/g, '/')).toLocaleDateString('ja-JP', opt)
    return dayjs(value).format('YYYY/MM/DD')
  },
}
